import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'beaconstac-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  /**
   * Maximum value
   */
  @Input()
  total = 100;

  /**
   * Current value
   */
  @Input()
  current = 25;

  /**
   * Maximum percentage value for Primary CSS
   */
  @Input()
  primaryThreshold: number = 90;

  /**
   * Maximum percentage value for Warning CSS
   */
  @Input()
  warningThreshold: number = 100;

   /**
   * Progress bar disabled
   */
  @Input()
  disabled: boolean = false;

  /**
   * If tooltip is not available for title description
   */
  @Input()
  tooltipEnabled: boolean = false;

   /**
   * Tooltip content (title description)
   */
   @Input()
   tooltipContent: string;

  /**
   * If progress bar does not change colors based on value
   */
  @Input()
  isSingleColor = true;

  /**
   * Color if single value
   */
  @Input()
  singleColorValue: string;

  /**
   * Title above progress bar
   */
  @Input()
  title = '';

  /**
   * Action button visibility
   */
  @Input()
  isActionButtonVisible: boolean;

  /**
   * Action button label
   */
  @Input()
  actionButtonLabel = '';

  /**
   * If action button is pressed
   */
  @Output()
  onActionButtonClicked = new EventEmitter<any>();

  /**
   * Hide the counts
   */
  @Input() displayCounts: boolean = true; 

  constructor() { }

  ngOnInit(): void {
  }

}
